<template>
  <b-modal
    v-if="message"
    id="modal-message"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    :title="message.title||$t('Message')"
    :ok-only="true"
    :ok-title="$t('Close')"
    @ok="close"
    @close="close"
  >

    <div class="text-center">
      <b-avatar
        size="60"
        :variant="message.variant"
      >
        <feather-icon
          size="38"
          :icon="message.icon"
        />
      </b-avatar>
      <h3 class="mt-1 mb-2">{{ message.title }}
        <br><small>{{ formatDate(message.createDate) }}</small>
      </h3>
      <p class="text-left">
        {{ message.body }}
      </p>

    </div>

  </b-modal>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BModal, VBModal, BAvatar,
} from 'bootstrap-vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export default {
  components: {
    BModal,
    BAvatar,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      message: null,
    }
  },
  mounted() {
    this.$root.$on('read_message', message => {
      this.message = message
      this.$nextTick(() => {
        this.$bvModal.show('modal-message')
        this.setAsRead()
      })
    })
  },
  beforeDestroy() {
    this.$root.$off('read_message')
  },
  methods: {
    setAsRead() {
      useJwt.axiosIns.patch(`message/setAsRead/${this.message.id}`)
        .then(() => {
          this.$root.$emit('refresh_messages')
        })
        .catch(e => {
          console.log(e)
        })
    },
    close() {
      this.$bvModal.hide('modal-message')
    },
    formatDate(date) {
      return dayjs(date).fromNow()
    },
  },
}
</script>
